

































































































































































import Vue from 'vue';
import {ToggleComponent} from '@mobi-components/toggle';
import VueSlider from 'vue-slider-component';
import LabelCheckBox from '../../../common-components/checkbox/label-checkbox.vue';
import {TransitPreferences} from '@/store/modules/itinerary-preferences/itinerary-preferences-types';

export default Vue.extend({
  name: 'ItineraryPreferencesTransit',
  components: {ToggleComponent, VueSlider, LabelCheckBox},
  props: {
    value: Object,
  },
  data() {
    // TODO:
    return {
      currentValue: this.value as TransitPreferences,
      // currentValue.allow_walking: true,
      // currentValue.allow_transit: true,
      // currentValue.allow_driving: true,
      // walkingTime: 3,
      // transitTime: 2,
      // busAndTrainTime: 1,
      // drivingTime: 3,
      // personalModes: [] as string[],

      //  allow_walking: boolean;
      //   allow_transit: boolean;
      //   allow_driving: boolean;
      //   max_walking_time_per_day: number; // in seconds
      //   max_transit_time_per_day: number; // in seconds
      //   max_driving_time_per_day: number; // in seconds
      //   max_mobility_time_per_day: number; // in seconds
      //   allowed_modes: string[]; //
    };
  },
  methods: {
    toggleWalking() {
      this.currentValue.allow_walking = !this.currentValue.allow_walking;
    },
    toggleBusTrainActive() {
      this.currentValue.allow_transit = !this.currentValue.allow_transit;
    },
    toggleDrivingActive() {
      this.currentValue.allow_driving = !this.currentValue.allow_driving;
    },
    handleSliderChange(
      value: number,
      prop: 'max_walking_time_per_day' | 'transitTime' | 'busAndTrainTime' | 'drivingTime',
    ) {
      // TODO:
    },
    handleSelect(value: string) {
      // if (this.personalModes.includes(value)) {
      //   return (this.personalModes = this.personalModes.filter((item) => item !== value));
      // }
      // this.personalModes = [...this.personalModes, value];
    },
  },
});
